import React from "react";
import { HashRouter as Router, Route, Routes } from "react-router-dom";
import "./App.css";

import Main from "./pages/Main.tsx";
import About from "./pages/About.tsx";
import Preview from "./pages/Preview.tsx";
import MyAccountPage from "./pages/Admin/MyAccountPage.tsx";
import PasswordPage from "./pages/Admin/PasswordPage.tsx";
import LoginPage from "./pages/LoginPage.tsx";
import PasswordForgotPage from "./pages/ForgotPasswordPage.tsx";
import RegisterPage from "./pages/RegisterPage.tsx";
import OrdersPage from "./pages/Admin/OrdersPage.tsx";
import CartPage from "./pages/CartPage.tsx";
import AddressesPage from "./pages/Admin/AdressesPage.tsx";
import CheckoutPage from "./pages/CheckoutPage.tsx";
import CheckoutPageSuccess from "./pages/CheckoutSuccessPage.tsx";
import ScrollToTop from "./scrollToTop.tsx";
import ContactsPage from "./pages/ContactsPage.tsx";
import AudioPlayerPage from "./pages/Admin/AudioPlayerPage.tsx";
import About2 from "./pages/AboutPage2.tsx";
import ResetPasswordPage from "./pages/ResetPasswordPage.tsx";

function App() {
  return (
    <Router>
      <div className="App">
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Main />} />
          <Route path="/about" element={<About />} />
          <Route path="/consultation" element={<About2 />} />
          <Route path="/preview" element={<Preview />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/cart" element={<CartPage />} />
          <Route path="/checkout" element={<CheckoutPage />} />
          <Route path="/contacts" element={<ContactsPage />} />
          <Route path="/checkout-success" element={<CheckoutPageSuccess />} />

          {/* Protected Admin Routes */}
          <Route path="/admin/myaccount" element={<MyAccountPage />} />
          <Route path="/admin/password" element={<PasswordPage />} />
          <Route path="/admin/orders" element={<OrdersPage />} />
          <Route path="/admin/addresses" element={<AddressesPage />} />
          <Route path="/admin/audio_player" element={<AudioPlayerPage />} />
          <Route
            path="/admin/password_forgot"
            element={<PasswordForgotPage />}
          />
          <Route
            path="/reset-password/:token"
            element={<ResetPasswordPage />}
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
